import type { Option } from '@cmg/common';

import { SecurityShareClass, SecurityType } from '../../../graphql';

export const securityTypeLabels = {
  [SecurityType.CommonOrdinaryShare]: 'Common/Ordinary Shares',
  [SecurityType.ConvertibleBond]: 'Convertible Bonds',
  [SecurityType.Fund]: 'Fund',
  [SecurityType.LimitedPartnershipUnit]: 'Limited Partnership Units',
  [SecurityType.PreferredShare]: 'Preferred Shares',
  [SecurityType.UnitShareAndWarrants]: 'Unit Share and Warrants',
};

// Fund is deliberately excluded here — it's only valid for Private Placement offerings.
// See PP_SECURITY_TYPE_OPTIONS below for the PP-specific set.
const DEFAULT_SECURITY_TYPES = [
  SecurityType.CommonOrdinaryShare,
  SecurityType.ConvertibleBond,
  SecurityType.LimitedPartnershipUnit,
  SecurityType.PreferredShare,
  SecurityType.UnitShareAndWarrants,
];

export const SECURITY_TYPE_OPTIONS = DEFAULT_SECURITY_TYPES.map<Option<SecurityType>>(type => ({
  label: securityTypeLabels[type],
  value: type,
}));

// Mirrors BE's SecurityType.PrivatePlacementSecurityTypes (src/Shared/Domain/Enum/SecurityType.cs)
// on the ECM-71574 branch — BE rejects any other value for Private Placement offerings.
// Exported (not just used locally) so BasicInfoForm.model.ts's Yup validation can reference
// the exact same list instead of duplicating it.
export const PP_SECURITY_TYPES = [
  SecurityType.CommonOrdinaryShare,
  SecurityType.PreferredShare,
  SecurityType.Fund,
];

export const PP_SECURITY_TYPE_OPTIONS = PP_SECURITY_TYPES.map<Option<SecurityType>>(type => ({
  label: securityTypeLabels[type],
  value: type,
}));

const CONVERTIBLE_SECURITY_TYPES = [SecurityType.ConvertibleBond, SecurityType.PreferredShare];

export const CONVERTIBLE_SECURITY_TYPE_OPTIONS = SECURITY_TYPE_OPTIONS.filter(option =>
  CONVERTIBLE_SECURITY_TYPES.includes(option.value)
);

export const securityShareClassOptions = Object.values(SecurityShareClass).map<
  Option<SecurityShareClass>
>(value => ({
  label: value,
  value,
}));
